import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { __decorate } from "tslib";
import { Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { RightManagementKey, RightManagementKeyGroup } from '@/store/enums/rightManagementEnum';
import store from '@/store';
import { RIGHT_MANAGMENT_CHANGE_FOR_GROUPE } from '@/store/actions/rightManagement';
import { RightManagementGroupParam } from '@/store/models/rightManagement';
var UserRightManagementSummary = /*#__PURE__*/function (_Vue) {
  function UserRightManagementSummary() {
    var _this;
    _classCallCheck(this, UserRightManagementSummary);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, UserRightManagementSummary, [].concat(args));
    _defineProperty(_this, "user", void 0);
    _defineProperty(_this, "loading", false);
    return _this;
  }
  _inherits(UserRightManagementSummary, _Vue);
  return _createClass(UserRightManagementSummary, [{
    key: "changeValueForGroup",
    value: function changeValueForGroup(keyGroup) {
      var _this2 = this;
      var value = this.getValueFor(keyGroup);
      var valString = 'false';
      if (value > 0) {
        // throw desactivate ALL
        valString = 'false';
      }
      if (value === 0) {
        // throw activate ALL
        valString = 'true';
      }
      var params = new RightManagementGroupParam();
      params.user = this.user;
      params.key = keyGroup;
      params.value = valString;
      this.loading = true;
      store.dispatch(RIGHT_MANAGMENT_CHANGE_FOR_GROUPE, params).then(function (resp) {
        _this2.loading = false;
      }).catch(function (err) {
        _this2.loading = false;
      });
    }
  }, {
    key: "isMe",
    get: function get() {
      var userConnected = store.getters.userConnected;
      if (this.user.userID === userConnected.userID) {
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: "typeForUser",
    get: function get() {
      return this.getTypeFor(RightManagementKeyGroup.MANAGE_USER);
    }
  }, {
    key: "typeForPlatform",
    get: function get() {
      return this.getTypeFor(RightManagementKeyGroup.MANAGE_PLATFORM);
    }
  }, {
    key: "typeForAuthItem",
    get: function get() {
      return this.getTypeFor(RightManagementKeyGroup.MANAGE_AUTHITEM);
    }
  }, {
    key: "changeValueForUserGroup",
    value: function changeValueForUserGroup() {
      this.changeValueForGroup(RightManagementKeyGroup.MANAGE_USER);
    }
  }, {
    key: "changeValueForPlatformGroup",
    value: function changeValueForPlatformGroup() {
      this.changeValueForGroup(RightManagementKeyGroup.MANAGE_PLATFORM);
    }
  }, {
    key: "changeValueForAuthItemGroup",
    value: function changeValueForAuthItemGroup() {
      this.changeValueForGroup(RightManagementKeyGroup.MANAGE_AUTHITEM);
    }
    // set the good style/type for a value of a group
  }, {
    key: "getTypeFor",
    value: function getTypeFor(keyGroup) {
      var value = this.getValueFor(keyGroup);
      if (value === 1) {
        return 'is-success';
      }
      if (value === 0.5) {
        return 'is-warning';
      }
      if (value === 0) {
        return '';
      }
    }
  }, {
    key: "isUserUpdateAivalable",
    get: function get() {
      return store.getters.isUpdateUserAivailable;
    }
    // can be 0 for duisabled
    // 0.5 partiel
    // 1 for full
  }, {
    key: "getValueFor",
    value: function getValueFor(keygroup) {
      return this.getGroupValue()[keygroup];
    }
  }, {
    key: "mounted",
    value: function mounted() {
      //   this.computeGroupValue();
    }
    // Compute the value of a group of right management
  }, {
    key: "getGroupValue",
    value: function getGroupValue() {
      var valueOfGroup = {};
      for (var _i = 0, _Object$values = Object.values(RightManagementKeyGroup); _i < _Object$values.length; _i++) {
        var key = _Object$values[_i];
        var numberOfKeyActive = 0;
        var numberOfKeyDisabled = 0;
        var _iterator = _createForOfIteratorHelper(new Set(this.user.rightManagement)),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var rm = _step.value;
            if (Object.values(RightManagementKey).includes(RightManagementKey[rm.key])) {
              if (rm.rightManagementGroup.includes(key)) {
                if (rm.value === "true") {
                  numberOfKeyActive++;
                } else {
                  numberOfKeyDisabled++;
                }
              }
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        if (numberOfKeyActive === 0) {
          valueOfGroup[key] = 0;
        } else if (numberOfKeyDisabled === 0) {
          valueOfGroup[key] = 1;
        } else {
          valueOfGroup[key] = 0.5;
        }
      }
      return valueOfGroup;
    }
  }]);
}(Vue);
export { UserRightManagementSummary as default };
__decorate([Prop()], UserRightManagementSummary.prototype, "user", void 0);